import script from "./FooterBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBlock.vue?vue&type=script&setup=true&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=58f09308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f09308"]])

export default __exports__